import { IRoleModel } from "../interfaces/IRoleModel";

export class Role implements IRoleModel {    
    idRol : number;
    nombre: string ;

    constructor(id: number, nombre: string){
        this.idRol = id;
        this.nombre = nombre;
    }
}

export enum Rol {
    Solicitante = 1,
    CoordinadorSSO = 2,
    Revisor = 3,
    Contratista = 4,
    Supervisor = 5,
    Administrador = 6,
    Vigilante = 7,
    AdministradorSSO = 8,
    ResponsableHIPO = 9
}